export const ADMIN_WIRE_TRANSFER_BUTTON_CLICK = 'Admin Wire Transfer Button Click';
export const ADMIN_SCREENSHOT_UPLOAD = 'Admin Screenshot Uploaded';
export const TOT_UPDATED = 'TOT Updated';
export const CREATE_REFUND_CLICKED = 'Create Refund Clicked';
export const REFUND_CREATED = 'Refund Created';
export const REFUND_STATUS_UPDATED = 'Refund Status Updated';
export const REFUND_PAGE_VIEWED = 'Refund Page Viewed';